import { render, staticRenderFns } from "./AddObjectProperties.vue?vue&type=template&id=55f05962&scoped=true&"
import script from "./AddObjectProperties.vue?vue&type=script&lang=js&"
export * from "./AddObjectProperties.vue?vue&type=script&lang=js&"
import style0 from "./AddObjectProperties.vue?vue&type=style&index=0&id=55f05962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f05962",
  null
  
)

export default component.exports